<template>
  <div
    v-if="isVisible"
    data-qa="petition_banner"
    :class="rootClass"
  >
    <CorePRG
      url="https://www.roi.ru/142775/"
      :button-attrs="{
        class: 'd-flex',
      }"
      @click="sendYaGoal('petitionBanner__click')"
    >
      <img
        class="rounded"
        width="100%"
        height="auto"
        :src="imageSrc"
        alt="Голосуй за безопасную медицину"
      >
    </CorePRG>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import useContextStore from 'src/store/useContextStore'
import CorePRG from 'src/core/CorePRG/CorePRG.vue'
import type { CommonContextStore } from 'src/types/context'
import useYandexGoals from 'src/composables/useYandexGoals'

/**
 * Баннер петиции «Голосуй за безопасную медицину».
 *
 * Аналог `common/doctors/include/petition_banner.html` для modern Vue SSR-страниц.
 * Показ зависит от `site_settings.show_petition_banner`.
 */
defineProps<{
  rootClass?: string
}>()

const { context }: CommonContextStore = useContextStore()
const isMobile = useIsMobile()

const isVisible = computed(() => Boolean(context.site_settings?.show_petition_banner))

const imageSrc = computed(() => {
  const staticPath = context.global?.static?.src || '/static/'
  const file = isMobile.value
    ? '_v1/pd/banners/petition-banner-short.jpg'
    : '_v1/pd/banners/petition-banner-long.jpg'

  return `${staticPath}${file}`
})

const { sendYaGoal } = useYandexGoals()
</script>
